// Render Prop

import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';

import SimpleField from "../../forms/SimpleField";
import { SelectField } from "../../forms/SelectField";


import { observer } from 'mobx-react';


import BackButton from "../../widgets/BackButton";
import AccountStatusDisplay from "../../widgets/AccountStatusDisplay";
import AccountInfoWidget from "../../widgets/AccountInfo";




class AccountStatusForm extends Component {
    static displayName = AccountStatusForm.name;

    constructor(props) {
        super(props);

        let account = props.store.accounts.getById(this.props.match.params.id)

        this.state = {
            account: account
        };

        if (account) {
            account = account.include(["student", "employer"]);

            const name = `${account.student.name} - ${account.employer.name}`;

            this.props.store.updateBanner("Update", name);
        }
    }

    async handleSubmission(values, setSubmitting) {

        let account = await this.state.account.addStatusUpdate(values, this.props.store);


        if (account.errors == null || account.errors.length == 0) {

            this.setState({
                account: account
            });
        }
    }

    validate(values) {
        const errors = {};

        if (values.status == "0") {
            errors.employerId = "Must select a status state."
        }

        return errors;
    }

    render() {
        //let account = props.store.accounts.getById(this.props.match.params.id)
        const key = "accountStatusDisplay-" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
        const accountInfoKey = "accountInfo-" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();

        return (
            <div>
                {this.introText()}
                <div className="row">
                    <div className="col-8">
                        {this.form()}
                        <br />
                        <AccountStatusDisplay key={key} accountId={this.props.match.params.id} store={this.props.store} />
                    </div>
                    <div className="col">
                        <AccountInfoWidget key={accountInfoKey} accountId={this.props.match.params.id} store={this.props.store} />
                    </div>
                </div>
            </div>
        )
    }

    setInitialValues() {

        return {
            accountId: this.state.account.id,
            note: "",
            status: "0",
        }
    }


    introText() {
        return (
            <div>
                <h1 className="h3">Update Account Status</h1>
            </div>
        )
    }

    form() {
        const statusOptions = [
            {
                id: "Locked",
                name: "Locked",
                key: 0
            },
            {
                id: "Active",
                name: "Active",
                key: 1
            }
        ]

        if (this.state.account) {
            return (

                <Formik
                    initialValues={this.setInitialValues()}
                    validate={values => this.validate(values)}
                    onSubmit={(values, { setSubmitting }) => this.handleSubmission(values, setSubmitting)}
                >
                    {({ isSubmitting }) => (

                        <Form>
                            <Field name="accountId" className="form-control" type="hidden" />

                            <SimpleField name="note" label="Note" type="text" />

                            <SelectField items={statusOptions} name="status" label="New Status" />

                            <div className="staffFormSubmitButtons">
                                <BackButton className="btn btn-secondary mr-2" innerText="Cancel" />
                                <button className="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik >
            )
        }

                
        else {
            return (
                <div>
                    <h3>Could not find account.</h3>
                </div>
            )
        };
    }
}


AccountStatusForm = observer(AccountStatusForm)

export { AccountStatusForm }